import React, { useEffect, useState, useRef } from "react";
import Flexbox from "flexbox-react";
import { inject, observer } from "mobx-react";
import { Icon } from "@blueprintjs/core";
import axios from "axios";
import Cookies from "js-cookie";
import "../goal_report/GoalReportPage.css";
import { SANKU_ACCOUNT_ID } from "../../static/Constant.js";
import CurrentUserStore from "../../stores/CurrentUserStore.js";
//Component imports
import PageHeading from "./PageHeading";
import GoalReportDataCard from "../goal_report/GoalReportDataCard";
import ReportTabSelector from "../goal_report/ReportTabSelector";
import GoalOverviewProgressChart from "../goal_report/GoalOverviewProgressChart";
import GoalCycleTrendsChart from "../goal_report/GoalCycleTrendsChart";
import GoalReportTeamsChart from "../goal_report/GoalReportTeamsChart";
import { getChangeIndicator } from "../goal_report/getChangeIndicator";
import FilledButton from "../buttons-20250224T111359Z-001/buttons/FilledButton.jsx";

const transformCardData = (originalCardData, icons = {}, goalCycleStatus) => {
  return Object.keys(originalCardData || {}).map(key => {
    const card = originalCardData[key];
    const change = card.change || "";
    const info = change ? getChangeIndicator(change) : "";

    return {
      keyName: key, // Pass key name (e.g., time_left)
      title: card.title,
      data: card.value,
      icon: icons[key] || null,
      info,
      timeCardText: card.end_date,
      currentScenario: card.current_senerio,
      goalCycleStatus
    };
  });
};

const GoalReportPage = inject("ToastStore")(
  observer(({ goalData, onClose, ...props }) => {
    const [activeTab, setActiveTab] = useState("overview");
    const [isDownloadButtonLoading, setIsDownloadButtonLoading] = useState(false);
    const [isDownloadBonusButtonLoading, setIsDownloadBonusButtonLoading] = useState(false);
    const [cardData, setCardData] = useState([]);
    const [goalOverviewAchievedData, setGoalOverviewAchievedData] = useState();
    const [goalOverviewSubmittedData, setGoalOverviewSubmittedData] = useState();
    const [goalTrendsReportData, setGoalTrendsReportData] = useState();
    const [goalCycleStatus, setGoalCycleStatus] = useState("");

    const getGoalCycleStatus = (startTime, endTime) => {
      const now = new Date();
      const start = new Date(startTime);
      const end = new Date(endTime);

      if (now < start) return "Not_Started";
      if (now >= start && now <= end) return "Ongoing";
      if (now > end) return "Ended";

      return "Unknown";
    };
    useEffect(() => {
      if (goalData?.start_time && goalData?.end_time) {
        const status = getGoalCycleStatus(goalData.start_time, goalData.end_time);
        setGoalCycleStatus(status);
      }
    }, [goalData?.start_time, goalData?.end_time]);

    const icons = {
      goals_achieved: (
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 48 48" fill="none">
          <path
            d="M21.32 21.3201C20.6065 22.0298 20.2037 22.9937 20.2 24.0001C20.2 25.0079 20.6003 25.9744 21.3129 26.6871C22.0256 27.3997 22.9921 27.8001 24 27.8001C25.0063 27.7964 25.9702 27.3936 26.68 26.6801"
            stroke="#3B82F6"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M24.0001 12.6001C21.7454 12.6001 19.5413 13.2687 17.6666 14.5213C15.7919 15.774 14.3307 17.5544 13.4679 19.6375C12.605 21.7206 12.3793 24.0127 12.8192 26.2241C13.259 28.4355 14.3448 30.4668 15.9391 32.0611C17.5334 33.6554 19.5647 34.7412 21.7761 35.1811C23.9875 35.6209 26.2796 35.3952 28.3627 34.5323C30.4458 33.6695 32.2262 32.2083 33.4789 30.3336C34.7315 28.4589 35.4001 26.2548 35.4001 24.0001"
            stroke="#3B82F6"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M24 5C20.2422 5 16.5687 6.11433 13.4442 8.20208C10.3196 10.2898 7.88436 13.2572 6.4463 16.729C5.00823 20.2008 4.63197 24.0211 5.36509 27.7067C6.09821 31.3924 7.90778 34.7778 10.565 37.435C13.2222 40.0922 16.6077 41.9018 20.2933 42.6349C23.9789 43.368 27.7992 42.9918 31.271 41.5537C34.7428 40.1156 37.7102 37.6804 39.7979 34.5558C41.8857 31.4313 43 27.7578 43 24M31.05 16.952L25.9 22.1"
            stroke="#3B82F6"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M41.8799 11.6879L35.3999 12.5999L36.3119 6.11995C36.3186 6.04468 36.3027 5.96913 36.2663 5.90294C36.2298 5.83676 36.1745 5.78295 36.1073 5.74838C36.0401 5.71382 35.9641 5.70007 35.889 5.7089C35.814 5.71773 35.7433 5.74873 35.6859 5.79795L31.3899 10.0719C30.9487 10.5164 30.6241 11.063 30.4451 11.6632C30.2661 12.2633 30.2382 12.8984 30.3639 13.5119L31.0479 16.9519L34.4879 17.6339C35.1015 17.7596 35.7366 17.7318 36.3367 17.5528C36.9369 17.3738 37.4835 17.0492 37.9279 16.6079L42.1999 12.3139C42.2493 12.2565 42.2804 12.1856 42.2892 12.1103C42.298 12.035 42.2841 11.9589 42.2492 11.8916C42.2144 11.8243 42.1603 11.7689 42.0937 11.7327C42.0272 11.6964 41.9514 11.6808 41.8759 11.6879"
            stroke="#3B82F6"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      goals_submitted: (
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 48 48" fill="none">
          <path
            d="M15.015 40.5H7.5V7.5H40.5V21M19.83 32.958L27.363 40.491L40.923 26.931"
            stroke="#A855F7"
            stroke-width="2"
            stroke-linejoin="round"
          />
        </svg>
      ),
      goals_approved: (
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 48 48" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.1719 4.2C21.8799 3.49295 22.8272 3.07691 23.8268 3.03396C24.8265 2.99101 25.8059 3.32428 26.5719 3.968L26.8279 4.202L30.6279 8H35.9999C37.0088 8.00019 37.9802 8.38155 38.7198 9.06768C39.4593 9.75381 39.9123 10.694 39.9879 11.7L39.9999 12V17.372L43.7999 21.172C44.5076 21.8801 44.9239 22.8277 44.9669 23.8279C45.0099 24.828 44.6762 25.8079 44.0319 26.574L43.7979 26.828L39.9979 30.628V36C39.9983 37.0092 39.6171 37.9811 38.931 38.7211C38.2448 39.4611 37.3043 39.9143 36.2979 39.99L35.9999 40H30.6299L26.8299 43.8C26.1219 44.5076 25.1742 44.924 24.1741 44.967C23.174 45.0099 22.1941 44.6763 21.4279 44.032L21.1739 43.8L17.3739 40H11.9999C10.9908 40.0003 10.0188 39.6192 9.27885 38.933C8.53888 38.2468 8.08563 37.3063 8.00994 36.3L7.99994 36V30.628L4.19994 26.828C3.49233 26.1199 3.07594 25.1723 3.03298 24.1721C2.99003 23.172 3.32364 22.1921 3.96794 21.426L4.19994 21.172L7.99994 17.372V12C8.00013 10.9912 8.38148 10.0197 9.06761 9.28018C9.75375 8.54064 10.694 8.08767 11.6999 8.012L11.9999 8H17.3719L21.1719 4.2Z"
            stroke="#22C55E"
            strokeWidth="2"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.1579 17.966L21.6699 26.454L18.1339 22.918C17.7586 22.5429 17.2497 22.3324 16.7192 22.3326C16.1886 22.3327 15.6799 22.5437 15.3049 22.919C14.9299 23.2942 14.7193 23.8031 14.7195 24.3337C14.7197 24.8642 14.9306 25.3729 15.3059 25.748L20.1139 30.556C20.3182 30.7604 20.5608 30.9225 20.8277 31.0331C21.0947 31.1438 21.3809 31.2007 21.6699 31.2007C21.9589 31.2007 22.245 31.1438 22.512 31.0331C22.779 30.9225 23.0216 30.7604 23.2259 30.556L32.9859 20.794C33.3502 20.4168 33.5518 19.9116 33.5472 19.3872C33.5427 18.8628 33.3323 18.3611 32.9615 17.9903C32.5907 17.6195 32.0891 17.4092 31.5647 17.4046C31.0403 17.4001 30.5351 17.6016 30.1579 17.966Z"
            fill="#22C55E"
          />
        </svg>
      ),
      time_left: (
        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 42 42" fill="none">
          <path
            d="M21 41C32.0457 41 41 32.0457 41 21C41 9.9543 32.0457 1 21 1C9.9543 1 1 9.9543 1 21C1 32.0457 9.9543 41 21 41Z"
            stroke="#F59E0B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M21 9V21L29 25" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    };

    useEffect(() => {
      if (goalData?.id) {
        fetchCardData();
        goalOverviewAchievedReport();
        goalOverviewSubmittedReport();
        goalTrendsReport();
      }
    }, [goalData?.id]);

    const fetchCardData = () => {
      axios
        .post(`${Cookies.get("apiEnv")}/insights_report/header_report_view`, {
          goal_setting_id: goalData.id
        })
        .then(response => {
          const originalCardData = response.data?.card_data;
          const transformedData = transformCardData(originalCardData, icons, goalCycleStatus);

          setCardData(transformedData);
        });
    };
    const goalOverviewAchievedReport = () => {
      axios
        .post(`${Cookies.get("apiEnv")}/insights_report/over_view/goal_achieved_report`, {
          goal_setting_id: goalData.id
        })
        .then(response => {
          console.log("achived data", response);
          setGoalOverviewAchievedData(response.data);
        });
    };

    const goalOverviewSubmittedReport = () => {
      axios
        .post(`${Cookies.get("apiEnv")}/insights_report/over_view/goal_submit_review`, {
          goal_setting_id: goalData.id
        })
        .then(response => {
          console.log("achived data", response);
          setGoalOverviewSubmittedData(response.data);
        });
    };
    const goalTrendsReport = () => {
      axios
        .post(`${Cookies.get("apiEnv")}/insights_report/trends/goal_cycle_performance`, {
          goal_setting_id: goalData.id
        })
        .then(response => {
          // console.log("achived data",response);
          setGoalTrendsReportData(response.data);
        });
    };

    const onDownloadReport = async () => {
      setIsDownloadButtonLoading(true);
      try {
        const response = await axios.get(
          `/goals/goal_report/${goalData.id}`,
          {
            responseType: "blob"
          }
        );
        const blob = new Blob([response.data], {
          type: "text/csv"
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${goalData.title.replace(/[^\w\s-]/g, "").trim().replace(/\s+/g, "_")}.csv`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error);
      } finally {
        setIsDownloadButtonLoading(false);
      }
    };

    const onDownloadBonusReport = async () => {
      setIsDownloadBonusButtonLoading(true);
      try {
        const response = await axios.get(
          `/goals/bonus_report/${goalData.id}`,
          {
            responseType: "blob"
          }
        );
        const blob = new Blob([response.data], {
          type: "text/csv"
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${goalData.title.replace(/[^\w\s-]/g, "").trim().replace(/\s+/g, "_")}.csv`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error);
      } finally {
        setIsDownloadBonusButtonLoading(false);
      }
    };

    return (
      <Flexbox flexDirection="column" flexGrow={1} marginBottom="20px">
        <Flexbox flexDirection="column" alignItems="flex-start" flexGrow={1}>
        </Flexbox>

        {CurrentUserStore?.activeAccount?.accountId === SANKU_ACCOUNT_ID && (
          <Flexbox display="flex" flexDirection="row" justifyContent="flex-end" style={{ gap: 10 }}>
            <FilledButton text="Download Report" onClick={onDownloadReport} disabled={isDownloadButtonLoading} />
            <FilledButton text="Download Bonus Report" onClick={onDownloadBonusReport} disabled={isDownloadBonusButtonLoading} />
          </Flexbox>
        )}
        <Flexbox display="flex" flexWrap="wrap" justifyContent="flex-start" gap="20px" className="push-20-t push-30-b" style={{ gap: '20px' }}>
          {cardData.map((card, index) => (
            <GoalReportDataCard key={index} card={card} />
          ))}
        </Flexbox>

        <ReportTabSelector activeTab={activeTab} onTabChange={tab => setActiveTab(tab)} className="push-30-t"></ReportTabSelector>
        {activeTab == "overview" && (
          <Flexbox display="flex" flexDirection="row" gap="20px" style={{ gap: "20px" }}>
            <GoalOverviewProgressChart
              title="Goals Achieved"
              subtitle="Goal status overview for the current cycle"
              goals={goalOverviewAchievedData?.goals}
              footerChangeText={goalOverviewAchievedData?.goals_in_progress_change}
              footerText={`${goalOverviewAchievedData?.total_number_archived_employee_goal} employees have achieved their goals`}
              // footerText={goalOverviewAchievedData?.total_number_archived_employee_goal}
              isCycleNotStarted={goalCycleStatus === "Not_Started"}
            />
            <GoalOverviewProgressChart
              title="Goals Submitted for Review"
              subtitle="Employee goal submission status for the current cycle"
              goals={goalOverviewSubmittedData?.goals}
              //footerText={goalOverviewSubmittedData?.total_number_submitter_employee_goal}
              footerText={`${goalOverviewSubmittedData?.total_number_submitter_employee_goal} employees have submitted their goals`}
              footerChangeText={goalOverviewSubmittedData?.goals_in_progress_change}
              isCycleNotStarted={goalCycleStatus === "Not_Started"}
            />
          </Flexbox>
        )}

        {activeTab == "trends" && (
          <Flexbox>
            <GoalCycleTrendsChart
              title="Goal Cycle Performance Over Time"
              subtitle="Compare key metrics for current goal cycle"
              trends={goalTrendsReportData.goal_data}
              isCycleNotStarted={goalCycleStatus === "Not_Started"}
            />
          </Flexbox>
        )}

        {activeTab == "employees" && <Flexbox></Flexbox>}
      </Flexbox>
    );
  })
);

export default GoalReportPage;